import { useCallback, useEffect, useState } from 'react'

import { useSelector } from 'react-redux'

import { makeSelectRole } from '@webapp/core/stores/global'
import { useFeatureFlag } from '@webapp/hooks'
import { IS_PROD } from '@webapp/infrastructure/envs'
import { PermissionGroupNames } from '@webapp/models'

export const useAppHeaderIntercomLauncher = () => {
  const DES_162_INTERCOM_TOPBAR_LAUNCHER = useFeatureFlag(
    'DES_162_INTERCOM_TOPBAR_LAUNCHER'
  )
  const FT_4880_ENABLE_INTERCOM = useFeatureFlag('FT_4880_ENABLE_INTERCOM')
  const role = useSelector(makeSelectRole())

  const [isOpen, setIsOpen] = useState(false)

  const isEnabled =
    DES_162_INTERCOM_TOPBAR_LAUNCHER &&
    FT_4880_ENABLE_INTERCOM &&
    IS_PROD &&
    !!role &&
    PermissionGroupNames.SITE_ADMINISTRATOR !== role.name &&
    !!window.Intercom

  useEffect(() => {
    if (!isEnabled) return

    window.Intercom('update', { hide_default_launcher: true })
    window.Intercom('onShow', () => setIsOpen(true))
    window.Intercom('onHide', () => setIsOpen(false))
  }, [isEnabled])

  const toggleMessenger = useCallback(() => {
    window.Intercom(isOpen ? 'hide' : 'show')
  }, [isOpen])

  return {
    states: { isEnabled, isOpen },
    commands: { toggleMessenger },
  }
}
